export { FiltersAccordion } from '@app/shared/components/FiltersAccordion/FiltersAccordion';
